import './swiffy-slider.min.css';
import './swiffy-slider.min.js';